import { ChangeEvent } from "react";
import { ToggleButton } from "components/buttons/ToggleButton";
import { useIsAuth } from "hooks";
import "./styles/ReportStepTwo.scss";

interface IProps {
  comment: string;
  onChangeComment: (event: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => void;
  isCanContact: boolean;
  handleIsCanContact: () => void;
  report: () => void;
}

export const ReportStepTwo = (props: IProps) => {
  const {
    comment,
    onChangeComment,
    isCanContact,
    handleIsCanContact,
  } = props;

  const isAuth = useIsAuth();

  return (
    <div className="ReportStepTwo">
      <p className="ReportStepTwo-Text">Is there are anything alse you want to add?</p>
      <textarea
        className="ReportStepTwo-TextArea"
        value={comment}
        onChange={onChangeComment}
        rows={3}
      />
      {isAuth && (
        <div className="ReportStepTwo-CheckWrap">
          <p>Can we contact you for more information</p>
          <ToggleButton
            checked={isCanContact}
            onChange={handleIsCanContact}
          />
        </div>
      )}
    </div>
  );
};
